module.exports = __webpack_public_path__ + "static/media/black_search_icon.8cfcbac8.svg";